import * as React from 'react';
import { CssPropertyAnalysisList } from './CssPropertyAnalysisList';

export const ClassificationsScreen: React.FC = () => {
  return <CssPropertyAnalysisList />;
};
